import TMModel from "@/modules/tm/api/tm/tm-model";
import TMDefines from "@/modules/tm/defines/tm-defines";
import React from "react";
import styles from "./index.module.scss";
import TMDetailInfoArea from "./info-area";
import TMDetailPersonArea from "./person-area";
import TMDetailPictureArea from "./picture-area";
import TMDetailPriceArea from "./price-area";
import TMDetailTitleArea from "./title-area";

export interface ITMDetailHeaderInfoProps {
  model: TMModel;
}

const TMDetailHeaderInfo: React.FC<ITMDetailHeaderInfoProps> = (props) => {
  let model = props.model;
  let person = model.spreadPerson;

  let photo = model.extend.photo;
  if (model.renderPhoto) photo = model.renderPhoto;

  return (
    <div className={`${styles.section} flex-row`}>
      <TMDetailPictureArea name={model.name} mainPicture={photo} />
      <div className={`${styles.rightContainer} flex-col`}>
        <TMDetailTitleArea
          name={model.name}
          code={model.code}
          type={TMDefines.GetTMRegTypeValue(model.type) ?? ""}
        />
        <TMDetailPriceArea price={model.price} deposit={model.price * 0.2} serviceRatio={0.05} />
        <div className="flex-row" style={{ flex: 1, marginTop: 20 }}>
          <TMDetailInfoArea
            code={model.code}
            category={model.classify}
            subCategory={model.subClassify}
          />
          <div className={styles.line} />
          <TMDetailPersonArea
            style={{ flex: "1" }}
            avatar={person?.avatar}
            name={person?.name}
            phone={person?.mobile}
            wechatQRCode={person?.wechatQRCode}
          />
        </div>
      </div>
    </div>
  );
};

export default TMDetailHeaderInfo;
